import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';

export const GET_USER_SETTINGS_MESSAGE_TYPE = 'get_user_settings';
export const getUserSettings = async (userId?: string) =>
  SocketAsFetch.fetch({
    message_type: GET_USER_SETTINGS_MESSAGE_TYPE,
    ...(userId && { info: { user_id: userId } }),
  });
